import { z } from 'zod';

export const approvalTypeSchema = z.object({
  libelle: z.string().min(1, 'Le libelle ne doit pas être vide').max(250, 'Le libelle ne doit pas dépasser 250 caractères'),
  organismeDeDeliveranceAgrementsId: z.number().min(1, "L'organisme de délivrance des agréments ne doit pas être vide"),
});
